import PropTypes from 'prop-types';
import React from 'react';

import { withFormikField, getFormikError } from 'utils/formik';
import ShipperField from './ShipperField';

const t = {
  placeholder: 'Choose Shipper',
  no_content: 'No shippers',
};

const ShipperSelector = ({ field, form, disabled, onChange, ...props }) => {
  const { name, value } = field;
  const { setFieldValue, setFieldTouched } = form;
  return (
    <div>
      <ShipperField
        {...props}
        placeholder={t.placeholder}
        small
        noResultsText={t.no_content}
        value={value}
        onChange={(shipper) => {
          onChange(shipper);
          setFieldValue(name, shipper);
          setFieldTouched(name);
        }}
        disabled={disabled}
        invalid={
          !!getFormikError({ field, form }) ||
          !!getFormikError({ field: { name: `${name}_id` }, form })
        }
        clearable={false}
        stylingProps={{
          fitWidth: 360,
          grow: true,
        }}
      />
    </div>
  );
};

ShipperSelector.propTypes = {
  shippers: PropTypes.array,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,

  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

ShipperSelector.defaultProps = {
  shippers: [],
  disabled: false,
  onChange: () => {
    /*noop*/
  },
  field: 'shipper',
};

export default withFormikField(ShipperSelector);
